import adminApiKeyAxiosInstance from "./adminApiKeyAxiosInstance";
import { AdminAPIResource } from "constants/adminApi";

export interface AdminIdentity {
  userName: string;
  emailId: string;
  cwid: string;
}

export interface AdminAccessCheckResponse {
  hasAccess: boolean;
  status: "APPROVED" | "PENDING" | "REJECTED" | "NOT_FOUND";
  message: string;
}

export interface AdminAccessRequestResponse {
  requestSubmitted: boolean;
  status: "PENDING" | "ALREADY_APPROVED";
  message: string;
}

export async function checkAdminAccess(
  cwid: string
): Promise<AdminAccessCheckResponse> {
  const { data } = await adminApiKeyAxiosInstance.post<AdminAccessCheckResponse>(
    AdminAPIResource.adminAccessCheck,
    { cwid }
  );
  return data;
}

export async function requestAdminAccess(
  identity: AdminIdentity,
  reason: string
): Promise<AdminAccessRequestResponse> {
  const { data } = await adminApiKeyAxiosInstance.post<AdminAccessRequestResponse>(
    AdminAPIResource.adminAccessRequest,
    { ...identity, reason }
  );
  return data;
}
